/* tslint:disable */
/* eslint-disable */
export enum ZatcaStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Failed = 'FAILED',
}
